import { useLocation, useNavigate } from "react-router-dom";
import { pageRoutes } from "../routes/PageRoutes";

const HeaderLabels = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = useLocation();


  const pageConfig = {
    [pageRoutes?.dashboard]: {
      title: "Dashboard",
    },
    [pageRoutes?.boat_docks]: {
      title: "Docks",
    },
    [pageRoutes?.add_new_docks]: {
      title: "Docks",
    },
    [pageRoutes?.update_docks]: {
      title: "Docks",
    },
    [pageRoutes?.dock_details]: {
      title: "Docks",
    },
    [pageRoutes?.all_boats]: {
      title: "Boats",
    },
    [pageRoutes?.boat_detail]: {
      title: "Boats",
    },
    [pageRoutes?.crate_boat]: {
      title: "Boats",
    },
    //  [pageRoutes?.AssignBoat]: {
    //   title: "Boats",
    // },
    [pageRoutes.technicians]: {
      title: "Technicians",
    },
    [pageRoutes.TechnicianDetail]: {
      title: "Technician",
    },
    [pageRoutes.AddTechnician]: {
      title: "Technician",
    },
    [pageRoutes.EditTechnician]: {
      title: "Technician",
    },
    [pageRoutes?.all_supplier]: {
      title: "Suppliers",
    },
    [pageRoutes?.SupplierDetail]: {
      title: "Suppliers",
    },
    [pageRoutes?.AddSupplier]: {
      title: "Suppliers",
    },
    [pageRoutes?.invoice_list_data]: {
      title: "Invoice System",
    },
    [pageRoutes?.Analytics]: {
      title: "Analytics",
    },
    [pageRoutes?.PartUsage]: {
      title: "Parts Management",
    },
    [pageRoutes?.quick_lead]: {
      title: "Leads",
    },
    [pageRoutes?.Customers]: {
      title: "Customer Profile",
    },
    [pageRoutes?.CustomerDetail]: {
      title: "Customer Profile",
    },
    [pageRoutes?.JobManagement]: {
      title: "Job Management",
    },
    [pageRoutes?.maintained_boats]: {
      title: "Job Management",
    },
    [pageRoutes?.boat_tracer]: {
      title: "Job Management",
    },
    [pageRoutes?.JobDetail]: {
      title: "Job Management",
    },
    [pageRoutes?.maintenance]: {
      title: "Maintenance ",
    },
    [pageRoutes?.MaintenanceDetails]: {
      title: "Maintenance ",
    },
    [pageRoutes?.CreateMaintenance]: {
      title: "Maintenance ",
    },
    // new pages
    [pageRoutes?.CustomerRequests]: {
      title: "Customer Requests",
    },
    [pageRoutes?.CustomerRequestDetail]: {
      title: "Customer Requests",
    },
    [pageRoutes?.CreateQuote]: {
      title: "Customer Requests",
    },
    [pageRoutes?.QuotesDetail]: {
      title: "Customer Requests",
    },
    [pageRoutes?.quotes]: {
      title: "Customer Requests",
    },


  };

  const currentPage = pageConfig[location.pathname] || {
    title: "",
    subtitle: "",
  };

  return (
    <div className="ct_inner_header_bg">
      <div className="">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
          <div className="d-flex gap-2 align-items-center">
            <div>
              <h4 className="ct_fs_20_head ct_idlewild_bold mb-0 ct_text_dark text-nowrap">
                {" "}
                {currentPage.title}
              </h4>
            </div>
          </div>
        </div>
      </div>

    </div>


  );
};

export default HeaderLabels;
